export class ExportInfos {
    id: string;
    fileName: string;
    debut: string;
    fin: string;
    typeFichier: string;
    statut: string;
}



// WEBPACK FOOTER //
// ./src/app/model/export-info.ts